<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'
import appConfig from '@src/app.config'
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      isLoading: false,
    }
  },
  computed: {},
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      this.isLoading = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        email: this.username,
        password: this.password,
      })
        .then((token) => {
          this.isLoading = false
          this.tryingToLogIn = false
          this.isAuthError = false
          if (token) {
            // Redirect to the originally requested page, or to the home page
            this.$router.push({ name: 'home' })
          } else {
            // Success Message
            this.$bvToast.toast('Invalid Login', {
              title: `Permission Error`,
              toaster: 'b-toaster-top-right',
              solid: true,
              variant: 'danger',
              appendToast: false,
            })
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
    restrictChars(event) {
      if (event.charCode === 32) {
        event.preventDefault()
      } else {
        return true
      }
    },

    showPassword() {
      let password = document.getElementById('input-2')
      if (password.type === 'password') {
        password.type = 'text'
      } else {
        password.type = 'password'
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="text-center">
          <a href="/">
            <span>
              <img src="@assets/images/logo.png" alt="mindZcloud" height="50" />
            </span>
          </a>
          <p class="text-muted mt-2 mb-4">{{ $t('login_header') }}</p>
        </div>
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center mb-4">
              <h4 class="text-uppercase mt-0">Sign In</h4>
            </div>

            <b-alert
              v-model="isAuthError"
              variant="danger"
              v-html="authError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="tryToLogIn"
            >
              <b-form-group
                id="input-group-1"
                label="Username"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="email"
                  parsley-trigger="change"
                  required
                  autofocus="autofocus"
                  placeholder="Enter username"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <label for="password">Password</label>
              <b-input-group style="padding:0;">
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  parsley-trigger="change"
                  required
                  placeholder="Enter password"
                  @keypress="restrictChars($event)"
                >
                </b-form-input>
                <template v-slot:append>
                  <b-input-group-text>
                    <a @click="showPassword"><i class="fa fa-eye"></i></a
                  ></b-input-group-text>
                </template>
              </b-input-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  >Log In</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>
                  {{ ' ' }}Loading...
                </b-button>
              </b-form-group>
            </b-form>
          </div>
          <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/forget-password" class="ml-1">
                <i class="fa fa-lock mr-1"></i>Forgot your password?
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
